import script from "./ElencoRilevazioni.vue?vue&type=script&setup=true&lang=js"
export * from "./ElencoRilevazioni.vue?vue&type=script&setup=true&lang=js"

import "./ElencoRilevazioni.vue?vue&type=style&index=0&id=98329b9a&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\alexg\\Desktop\\martech\\whappy-app-front-vue-v2\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-98329b9a"]])

export default __exports__